import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import {
  TalkJsContext,
  TalkJsContextInterface,
  UserDetailsContext,
} from "../../contexts";
import { Box } from "@material-ui/core";
import { StyledAvatar, SendMessageButton } from "./styles";
import { styles, CustomIconButtonForPlay } from "./styles";
import { CustomScrollingContainer, TopContainer } from "./styles";
import { UserNameBioContainer, GenreAndSkillsContainer } from "./styles";
import { TitlesContainer, TrackContainer } from "./styles";
import { ButtonText, UserDetailsContainer } from "./styles";
import { useGetPublicUser } from "../../hooks/useGetPublicUser";
import {
  CircularProgress,
  IconButton,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { Button, Typography } from "@mui/material";
import { MusicNFT } from "../ExploreBase/types";
import { getPublishedTrack } from "../../services/trackService";
import { GetPublishedTracksResponse, User } from "../../proto/api_pb";
import { Collaborator } from "../../proto/api_pb";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { GetTrackResponse } from "../../proto/api_pb";
import { RpcError } from "grpc-web";
import { getThumbnailUrl } from "../../utils/thumbnailUtil";
import { collaboratorsStyles } from "../TracksPageComponents/styles";
import { THEME } from "../../theme";
import { CustomizedTooltip } from "../TracksPageComponents/Collaborators";
import { handleGetPublishedTracksResponse } from "./helper";
import { MobileScreenBottomNavigationContainer } from "../../pages/Tracks/styles";
import { MobileScreenBottomNavigation } from "../TracksPageComponents/MobileScreenBottomNavigation";
import { AudioPlayer } from "../TracksPageComponents/AudioPlayer";
import { TrackToPlay } from "../../pages/ExplorePage/types";
import { useAuth0 } from "@auth0/auth0-react";
import PauseCircleOutlineRoundedIcon from "@mui/icons-material/PauseCircleOutlineRounded";
import { secondsToMinutes } from "../TracksPageComponents/helper";
import { MoreBio, PersonalLinks } from "./MoreBio";
import { StyledProfilePic } from "../ExploreBase/styles";
import { UserProfileProps } from "./types";
import { MobileDrawer } from "../MobileDrawer/MobileDrawer";
import { handleCreateGroupChat } from "../TrackComponents/TrackHandler/trackHandlers";

export const UserProfile: React.FC<UserProfileProps> = ({
  session,
  setInbox,
}) => {
  const [publishedTracks, setPublishedTracks] = useState<GetTrackResponse[]>(
    []
  );
  const [tracks, setTracks] = useState<Array<MusicNFT>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const loadingRef = useRef<HTMLDivElement | null>(null);
  const [trackToPlay, setTrackToPlay] = useState<TrackToPlay>();
  const [isPlayButtonClicked, setIsPlayButtonClicked] =
    useState<boolean>(false);
  const [sendMessageClicked] = useState(false);
  const username = useParams();
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const { user, getUserResponse, getUserError } = useGetPublicUser(
    username["usr"]
  );
  const { userName } = useContext(UserDetailsContext);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState("");
  const { enterprise, isEnterpriseAccount } = useContext(UserDetailsContext);

  const content = isAuthenticated
    ? username["usr"] === userName
      ? { text: "Settings", icon: <ManageAccountsIcon /> }
      : { text: "Send Message", icon: <EmailIcon /> }
    : { text: "Log in/ Sign up", icon: null };

  useEffect(() => {
    const helper = async () => {
      if (getUserResponse?.getProfilePicture()) {
        const thumbnailUrl = await getThumbnailUrl(
          getUserResponse.getProfilePicture()
        );
        setProfileImage(thumbnailUrl);
      }
    };
    helper();
  }, [getUserResponse]);

  const talkJsContext = useContext<TalkJsContextInterface>(TalkJsContext);

  const handleButtonClick = (contributors: User[] | Collaborator[]) => {
    if (isAuthenticated && user) {
      const allCollaborators: Collaborator[] = [];
      contributors.map((contributor) => {
        const collaborator = new Collaborator();
        collaborator.setUserId(contributor.getUserId());
        collaborator.setUsername(contributor.getUsername());
        collaborator.setProfilePicture(contributor?.getProfilePicture());
        allCollaborators.push(collaborator);
      });
      if (username["usr"] === userName) {
        navigate("/profile");
        return;
      }
      if (isSmallScreen) {
        navigate("/messages");
        return;
      }
      handleCreateGroupChat(
        talkJsContext,
        contributors,
        navigate,
        undefined,
        undefined,
        undefined
      );
    } else {
      loginWithRedirect({
        appState: { returnTo: "/my-tracks" },
        authorizationParams: { screen_hint: "signup" },
      });
    }
  };

  const getPublishTracks = useCallback(async () => {
    setIsLoading(true);
    try {
      if (user) {
        const isFeaturedArtistTrack = false;
        const response = await getPublishedTrack(
          0,
          100,
          [],
          "",
          isFeaturedArtistTrack,
          user.getUserId(),
          ""
        );
        if (response instanceof RpcError) {
          throw response;
        }
        if (response instanceof GetPublishedTracksResponse) {
          const publishedTrack = await handleGetPublishedTracksResponse(
            response
          );

          setPublishedTracks(response.getTracksList());
          setTracks(publishedTrack);
        }
      }
    } catch (er) {
      console.log(er);
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  useEffect(() => {
    getPublishTracks();
  }, [getPublishTracks]);

  useEffect(() => {
    if (isLoading && loadingRef.current) {
      loadingRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [isLoading]);

  useEffect(() => {
    if (sendMessageClicked && talkJsContext) {
      talkJsContext.createConversation();
    }
  }, [talkJsContext, sendMessageClicked]);

  let skillsDiv = <div></div>;
  let genresDiv = <div></div>;
  if (getUserResponse && getUserResponse?.getSkillsList().length > 0) {
    skillsDiv = (
      <UserDetailsContainer>
        <Box>
          <p style={{ wordBreak: "break-word" }}>
            Skills:
            {getUserResponse?.getSkillsList().join(", ")}
          </p>
        </Box>
      </UserDetailsContainer>
    );
  }
  if (getUserResponse && getUserResponse?.getGenresList().length > 0) {
    genresDiv = (
      <UserDetailsContainer>
        <Box>
          <p style={{ wordBreak: "break-word" }}>
            Genres: {getUserResponse?.getGenresList().join(", ")}
          </p>
        </Box>
      </UserDetailsContainer>
    );
  }

  if (getUserError) {
    navigate("/not-found", { replace: true });
    return <></>;
  }

  return (
    <>
      <MobileDrawer />
      <Box sx={styles.userProfileContainer}>
        <Box sx={styles.userProfileBox}>
          <Box sx={styles.userProfile}>
            <Button
              onClick={() => {
                navigate(-1);
              }}
              sx={styles.backButton}
            >
              <ArrowBackIcon sx={{ marginRight: "10px" }} /> Back
            </Button>
          </Box>
          <TopContainer>
            <Box sx={styles.avatarAndMessageButtonContainer}>
              <StyledAvatar
                variant={"rounded"}
                alt="profile picture"
                src={profileImage}
              />
              <SendMessageButton
                sx={{ marginTop: "15px", textTransform: "none" }}
                variant="contained"
                onClick={() => {
                  if (user) handleButtonClick([user]);
                }}
              >
                {content.icon}&nbsp;&nbsp;
                <ButtonText variant="subtitle1">{content.text}</ButtonText>
              </SendMessageButton>
            </Box>
            <UserNameBioContainer>
              <Typography sx={{ fontWeight: "bold" }} variant="h5">
                {user?.getUsername()}
              </Typography>
              {user && (
                <Box>
                  {user.getBio().substring(0, 190)}
                  {user.getBio().length > 190 && <MoreBio user={user} />}
                </Box>
              )}
              <PersonalLinks currentUser={getUserResponse} />
            </UserNameBioContainer>
            {getUserResponse &&
            (getUserResponse?.getGenresList().length > 0 ||
              getUserResponse?.getSkillsList().length > 0) ? (
              <GenreAndSkillsContainer>
                {genresDiv}
                {skillsDiv}
              </GenreAndSkillsContainer>
            ) : (
              <></>
            )}
          </TopContainer>
          <Box sx={{ margin: "10px" }}>
            <TitlesContainer>
              <Typography>Name</Typography>
              <Typography sx={{ marginLeft: "30px" }}>Collaborators</Typography>
              <Typography>Message Collaborators</Typography>
            </TitlesContainer>
            <CustomScrollingContainer>
              {tracks.map((t, i) => {
                return (
                  <Box sx={styles.trackContainer} key={i}>
                    <TrackContainer>
                      <Box sx={styles.trackContainerBox}>
                        <img
                          src={
                            t.image.includes("http")
                              ? t.image
                              : isEnterpriseAccount
                              ? enterprise?.image
                              : "/assets/images/logo512.png"
                          }
                          style={styles.trackLogo}
                          alt=""
                        />
                        <CustomIconButtonForPlay
                          onClick={(e) => {
                            setTrackToPlay((prev) => {
                              const isPlaying = prev?.isPlaying
                                ? !prev.isPlaying
                                : true;
                              return {
                                track: publishedTracks[i].getTrack(),
                                url: publishedTracks[i]
                                  .getTrackVersion()
                                  ?.getTrackUrl(),
                                isPlaying:
                                  trackToPlay?.track?.getId() ===
                                  publishedTracks[i].getTrack()?.getId()
                                    ? isPlaying
                                    : true,
                              };
                            });
                            setIsPlayButtonClicked(true);
                          }}
                        >
                          {trackToPlay?.isPlaying &&
                          trackToPlay?.track?.getId() ===
                            publishedTracks[i].getTrack()?.getId() ? (
                            <PauseCircleOutlineRoundedIcon
                              sx={{ fontSize: "20px" }}
                            />
                          ) : (
                            <img
                              style={styles.play}
                              src="/assets/icons/TracksPageIcons/play.svg"
                              alt="icon"
                            />
                          )}
                        </CustomIconButtonForPlay>
                        <Box sx={styles.trackDetailsContainer}>
                          <Typography>{t.title}</Typography>
                          <Typography>
                            {secondsToMinutes(
                              publishedTracks[i]
                                .getTrackVersion()
                                ?.getLengthSeconds() ?? 0
                            )}
                            {publishedTracks[i]
                              .getTrackVersion()
                              ?.getAudioMetadata()
                              ?.getBpm()}{" "}
                            BPM
                            {`${publishedTracks[i]
                              .getTrackVersion()
                              ?.getAudioMetadata()
                              ?.getKey()}`}
                          </Typography>
                          <Typography>
                            {publishedTracks[i]
                              .getTrack()
                              ?.getSongMetadata()
                              ?.getGenre()}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={collaboratorsStyles.collaboratorsContainer}>
                        {publishedTracks[i]
                          .getTrack()
                          ?.getCollaboratorsList()
                          .map((el) => {
                            const userProfileRoute = `/user-profile/${el.getUsername()}`;
                            return (
                              <CustomizedTooltip
                                title={el.getUsername()}
                                key={el.getUserId()}
                                placement="top"
                              >
                                <NavLink
                                  to={userProfileRoute}
                                  state={{ userId: el.getUserId() }}
                                  style={collaboratorsStyles.navLink}
                                  key={el.getUserId()}
                                >
                                  <StyledProfilePic
                                    key={el.getUsername()}
                                    variant={"rounded"}
                                    alt="profile picture"
                                    src={el.getProfilePicture()}
                                  />
                                </NavLink>
                              </CustomizedTooltip>
                            );
                          })}
                      </Box>
                      <Box sx={styles.actionsContainer}>
                        <IconButton
                          onClick={(e) => {
                            if (session) {
                              const talkInbox = session.createInbox();
                              setInbox(talkInbox);
                              talkJsContext.setIsChatOpen(true);
                            }
                            const collaborators = publishedTracks[i]
                              .getTrack()
                              ?.getCollaboratorsList();
                            if (collaborators) {
                              handleButtonClick(collaborators);
                            }
                            if (isSmallScreen) navigate("/messages");
                          }}
                        >
                          <Tooltip
                            placement="top"
                            title="Chat with the artists"
                          >
                            <img
                              style={{
                                filter:
                                  THEME === "light"
                                    ? "invert(100%)"
                                    : "invert(0%)",
                              }}
                              src="/assets/icons/TracksPageIcons/message-chat-circle.svg"
                              alt="icon"
                            />
                          </Tooltip>
                        </IconButton>
                      </Box>
                    </TrackContainer>
                  </Box>
                );
              })}
              {isLoading && (
                <div style={styles.loadingContainer} ref={loadingRef}>
                  <CircularProgress size={50} />
                </div>
              )}
            </CustomScrollingContainer>
          </Box>
        </Box>
      </Box>
      <MobileScreenBottomNavigationContainer>
        <MobileScreenBottomNavigation />
      </MobileScreenBottomNavigationContainer>
      <AudioPlayer
        trackToPlay={trackToPlay}
        isPlayButtonClicked={isPlayButtonClicked}
        versionToPlay={undefined}
        isTrackForPlay={true}
        audioDetails={{
          title: trackToPlay?.track?.getTitle() ?? "",
          image: trackToPlay?.track?.getImageUrl() ?? "",
        }}
        setTrackToPlay={setTrackToPlay}
        setIsPlayButtonClicked={setIsPlayButtonClicked}
      />
    </>
  );
};
